// A screenshot of the restaurant's shop in the platform agent's panel (contracts §5 card shop_screenshot, §9).
export default {
  title: {
    phone: 'Your shop on a phone',
    desktop: 'Your shop on a computer',
  },
  loading: 'Loading the screenshot',
  failed: "The screenshot couldn't be loaded.",
};
